export * from './post-fond.component';
export * from './post-fond.component.module';